<template>
  <dl class="w-100">
    <template v-if="depositRequest">
      <dt>Amount:</dt>
      <dd>
        {{
          depositRequest.deposit?.changeAmount
            ? `£${-depositRequest.deposit?.changeAmount}`
            : "-"
        }}
      </dd>
      <dt>Deposit Deadline:</dt>
      <dd>{{ deadlineDate ?? "-" }}</dd>
      <template v-if="!depositRequest.onlyShowDeadline">
        <dt>Reference:</dt>
        <dd>{{ depositRequest.deposit?.reference ?? "-" }}</dd>
        <dt>Date Taken:</dt>
        <dd>{{ dateTaken ?? "-" }}</dd>
        <dt>Date Returned:</dt>
        <dd>{{ dateReturned ?? "-" }}</dd>
      </template>
    </template>
  </dl>
</template>

<script lang="ts">
  import { formatDate } from "@/helpers/dateHelper"
  import { ITransaction } from "@/models/transaction/transaction.types"
  import dayjs, { Dayjs } from "dayjs"
  import advancedFormat from "dayjs/plugin/advancedFormat"
  import { defineComponent, PropType } from "vue"

  dayjs.extend(advancedFormat)

  export default defineComponent({
    props: {
      depositRequest: {
        type: Object as PropType<{
          deposit: ITransaction | undefined
          refund: ITransaction | undefined
          deadline: Dayjs | undefined
          onlyShowDeadline: boolean
        }>,
        required: true,
      },
    },
    computed: {
      dateTaken() {
        return formatDate(dayjs(this.depositRequest.deposit?.acceptedDttm))
      },
      deadlineDate() {
        return formatDate(this.depositRequest.deadline)
      },
      dateReturned() {
        return this.depositRequest.refund?.acceptedDttm
          ? formatDate(dayjs(this.depositRequest.refund?.acceptedDttm))
          : undefined
      },
    },
  })
</script>

<style scoped>
  dt:before {
    content: "";
    display: block;
  }
  dt,
  dd {
    margin-right: 5px;
    display: inline;
  }
</style>
